import type { Filter } from './types';

function get(obj: any, path: string) {
	const keys = path.split('.');
	let result = obj;

	for (const key of keys) {
		if (result === undefined) return undefined;
		result = result[key];
	}

	return result;
}

// Преобразует фильтры из стиля Kuzzle (koncord) в dexie.js

// Аналог такой функции
// function createFilterPredicate(filterConfig: FilterConfiguration): Function {
//   return function(element: any): boolean {
//     // Логика фильтрации
//     return true/false;
//   }
// }

function isPathNested(path: string): boolean {
	return path.includes('.');
}

// function convertEqualsToArraySearch(path: string, value: any): Filter {
// 	return {
// 		or: [
// 			{ equals: { [path]: value } }, // Прямое сравнение
// 			{
// 				equals: {
// 					[path.split('.')[0]]: {
// 						// Берем первую часть пути (например 'caravan' из 'caravan.id')
// 						[path.split('.').slice(1).join('.')]: value, // Остальная часть пути
// 					},
// 				},
// 			},
// 		],
// 	};
// }

export const filterConvertation = (filter: Filter): ((item: any) => boolean) => {
	if (!filter) {
		return () => true;
	}

	if (filter.exists) {
		const path = filter.exists; // Сохраняем в переменную иначе ругается ts
		return (item: any) => get(item, path) !== undefined;
	}

	// if (filter.equals) {
	// 	const conditions = filter.equals;
	// 	return (item: any) => {
	// 		return Object.entries(conditions).every(([path, value]) => get(item, path) === value);
	// 	};
	// }

	if (filter.equals) {
		const conditions = filter.equals;

		return (item: any) => {
			return Object.entries(conditions).every(([path, value]) => {
				if (!isPathNested(path)) {
					// Для простых путей - обычное сравнение
					return get(item, path) === value;
				}

				// Для вложенных путей (с точкой)
				const directMatch = get(item, path) === value;

				// Разбиваем путь для проверки массива
				const [firstPart, ...restParts] = path.split('.');
				const firstLevelValue = item[firstPart];

				// Проверяем, является ли значение массивом
				const arrayMatch =
					Array.isArray(firstLevelValue) && firstLevelValue.some((elem) => get(elem, restParts.join('.')) === value);

				return directMatch || arrayMatch;
			});
		};
	}

	// if (filter.equals) {
	// 	const conditions = filter.equals;

	// 	// Проверяем, есть ли вложенные пути
	// 	const hasNestedPaths = Object.keys(conditions).some(isPathNested);

	// 	if (hasNestedPaths) {
	// 		return (item: any) => {
	//       return Object.entries(conditions).every(([path, value]) => {
	//         // Для вложенных путей проверяем оба варианта
	//         if (isPathNested(path)) {
	//           const directMatch = get(item, path) === value;

	//           // Разбиваем путь и проверяем как массив
	//           const [firstPart, ...restParts] = path.split('.');
	//           const arrayMatch = Array.isArray(item[firstPart]) &&
	//             item[firstPart].some(elem => get(elem, restParts.join('.')) === value);

	//           return directMatch || arrayMatch;
	//         }
	//         // Для простых путей - обычное сравнение
	//         return get(item, path) === value;
	//       });
	//     };
	// 	}

	// 	// 	// Преобразуем каждое условие equals в OR с проверкой массива
	// 	// 	const orConditions = Object.entries(conditions).map(([path, value]) => convertEqualsToArraySearch(path, value));

	// 	// 	// Если условий несколько, объединяем их через AND
	// 	// 	if (orConditions.length > 1) {
	// 	// 		return filterConvertation({ and: orConditions });
	// 	// 	}

	// 	// 	// Если условие одно, просто возвращаем его обработчик
	// 	// 	return filterConvertation(orConditions[0]);
	// 	// }

	// 	// Для простых equals используем старую логику
	// 	return (item: any) => {
	// 		return Object.entries(conditions).every(([path, value]) => get(item, path) === value);
	// 	};
	// }

	if (filter.regexp) {
		const patterns = filter.regexp;
		return (item: any) => {
			return Object.entries(patterns).every(([path, pattern]) => {
				const value = get(item, path);
				return new RegExp(pattern).test(value);
			});
		};
	}

	if (filter.range) {
		const range = filter.range;
		return (item: any) => {
			return Object.entries(range).every(([path, conditions]) => {
				const value = get(item, path);
				return Object.entries(conditions).every(([operator, threshold]) => {
					switch (operator) {
						case 'gte':
							return value >= threshold;
						case 'gt':
							return value > threshold;
						case 'lte':
							return value <= threshold;
						case 'lt':
							return value < threshold;
						default:
							return true;
					}
				});
			});
		};
	}

	if (filter.ids) {
		const ids = filter.ids;
		return (item: any) => ids.values.includes(item.id);
	}

	if (filter.in) {
		const inFilter = filter.in;
		return (item: any) => {
			return Object.entries(inFilter).every(([path, values]) => values.includes(get(item, path)));
		};
	}

	if (filter.not) {
		const innerFilter = filterConvertation(filter.not);
		return (item: any) => !innerFilter(item);
	}

	if (filter.and) {
		const innerFilters = filter.and.map(filterConvertation);
		return (item: any) => innerFilters.every((f) => f(item));
	}

	if (filter.or) {
		const innerFilters = filter.or.map(filterConvertation);
		return (item: any) => innerFilters.some((f) => f(item));
	}

	return () => true;
};

export const applySorting = (sorts: Array<Record<string, 'asc' | 'desc'>> | undefined) => {
	// Если сортировка не задана, возвращаем исходный порядок
	if (!sorts?.length) {
		return () => 0;
	}

	return (a: any, b: any) => {
		// Проходим по всем правилам сортировки
		for (const sortRule of sorts) {
			try {
				const [field, direction] = Object.entries(sortRule)[0];

				// Получаем значения вложенных полей через split('.')
				const aValue = field.split('.').reduce((obj, key) => {
					if (obj === undefined || obj === null) {
						throw new Error(`Поле ${field} не существует в документе`);
					}
					return obj[key];
				}, a);

				const bValue = field.split('.').reduce((obj, key) => {
					if (obj === undefined || obj === null) {
						throw new Error(`Поле ${field} не существует в документе`);
					}
					return obj[key];
				}, b);

				// Обработка null/undefined значений
				if (aValue === undefined || aValue === null) {
					return direction === 'asc' ? -1 : 1; // null всегда "меньше"
				}
				if (bValue === undefined || bValue === null) {
					return direction === 'asc' ? 1 : -1;
				}

				// Если значения разные, возвращаем результат сравнения
				if (aValue !== bValue) {
					return direction === 'asc' ? (aValue > bValue ? 1 : -1) : aValue < bValue ? 1 : -1;
				}
			} catch (error) {
				console.warn(`Ошибка при сортировке: ${error}`);
				// continue; // Пропускаем проблемное правило сортировки
			}
		}
		return 0; // если все значения равны
	};
};
